import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { USAEPAYAchPage } from './usaepay-ach.page';

const routes: Routes = [
  {
    path: '',
    component: USAEPAYAchPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class USAEPAYAchPageRoutingModule {}
